import React, { Component } from 'react';
import { Link } from "react-router-dom";

export default class extends Component {
  constructor(props) {
      super(props);
      this.state = {
          componentReady: 'ready'
      };
  }
  goBack = () =>{
    this.props.history.goBack();
  }
  render() {
    return (
    <div className={'small-padding'}>
      {this.props.title && <h4>{this.props.title}</h4>}
      {this.props.description && <p className="subheading" style={{marginTop:"30px"}}>{this.props.description}</p>}
      {this.props.link && <Link className="button primary-background white" to={this.props.link} style={{color:this.props.buttonColor,backgroundColor:this.props.backgroundColor, marginTop:"20px"}}>{this.props.linkText}</Link>}
      {this.props.hrefLink && <a target="_blank" className="button primary-background white" href={this.props.hrefLink} style={{color:this.props.buttonColor,backgroundColor:this.props.backgroundColor, marginTop:"20px"}}>{this.props.linkText}</a>}
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/alpineComponents/centeredParagraph/index.js